import {
  PRESUPUESTADOR_SAVE_PRESUPUESTO_BEGIN,
  PRESUPUESTADOR_SAVE_PRESUPUESTO_SUCCESS,
  PRESUPUESTADOR_SAVE_PRESUPUESTO_FAILURE,
  PRESUPUESTADOR_SAVE_PRESUPUESTO_DISMISS_ERROR,
} from './constants'
import { getEndpoint } from '../../common/backend/endpoints'
import { calculateDiscounts } from '../../common/Utilities'
import axios from 'axios'
import { truncNumber } from 'common/utils/utils'

// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html

export function savePresupuesto() {
  return (dispatch, getState) => {
    dispatch({
      type: PRESUPUESTADOR_SAVE_PRESUPUESTO_BEGIN,
    })

    const {presupuestador = {}, common = {}, peritador={}} = getState()
    const endpoint = getEndpoint('PRESUPUESTADOR')
    const promise = new Promise((resolve, reject) => {
      
      //Obtengo TNA
      let valor_tna = 0
      presupuestador.lineasFinancieras.forEach(linea => {
        if(linea.id === presupuestador.selectedLineaFinanciera) {
          linea.lines.forEach(line => {
            if(line.quantity === presupuestador.cuotasAfinanciar){
              valor_tna = line.tna
            }
          })
        }
      })

      const originChannelName = presupuestador.nuevo.nuevo ? '0km' : 'usados'
      const origin_channel_id = peritador.originChannels
        .find(oc => String(oc.name).toLowerCase() === originChannelName).id

      //Convierto los datos de los autos entregados
      const entrega_usados = presupuestador.entregaUsados.map(usado => {

        return {
          quotation_id: usado.quotation_id, // id Cotización
          taking_auth_id: '', // id de la autorizacion de toma (cuando se modifica a mano)
          final_take_price: (!usado.updatedTakePriceWasModified && usado.appraisal) ? usado.appraisal + (usado.take_improvement_amount || 0) : usado.final_take_price,
          use_take_improvement: false, // si se modificó a mano el importe va true o false
          original_price: usado.original_price,
          take_improvement_amount: usado.take_improvement_amount || 0,
          year: usado.year,
          brand: usado.brand,
          model: usado.model,
          version: usado.version,
          version_id: usado.versionId || usado.id,
          license_plate: usado.patente,
          mileage: usado.km ? usado.km : 0,
          assessed: usado.peritado ? Number(usado.peritado) : null,
          verification_date: usado.verificationDate ? usado.verificationDate : null,
          requestsId: usado.requestsId,
          updatedTakePrice: usado.updatedTakePriceWasModified ? usado.updatedTakePrice : null,
          appraisal: usado.updatedTakePriceWasModified ? usado.updatedTakePrice : null,
          branch_office_id: presupuestador.nuevo.branch_office_id,
          car_lot_id: presupuestador.nuevo.car_lot_id,
          origin_channel_id
        }
      })

      //Armo el body

      //Obtengo el stock seleccionado
      let stock = null
      if(presupuestador.selectedStock){
        presupuestador.nuevo.Stocks.forEach(st=>{
          if(st.id === presupuestador.selectedStock){
            stock = st
          }
        })
      }

      let lineaFinanciera = null
      if(presupuestador.selectedLineaFinanciera) {
        presupuestador.lineasFinancieras.forEach(linea=>{
          if(linea.id === presupuestador.selectedLineaFinanciera){
            lineaFinanciera = linea
          }
        })
      }

      let stock_color = stock?.idColor || null
      if(!stock_color && presupuestador.nuevo.nuevo === false && presupuestador.nuevo.colors.length === 1) {
        stock_color = presupuestador.nuevo.colors[0].id
      }
      
      const { maxDiscount, usedDiscount } = calculateDiscounts({
        catalog: {...presupuestador.nuevo},
        profileDiscounts: presupuestador.profileDiscounts,
        carLotId: presupuestador.nuevo?.car_lot_id,
        saleType : presupuestador.nuevo.nuevo ? presupuestador.tipoVentaSelected === "venta_directa" ? "DIRECTA" : "CONVENCIONAL" : "USADOS",
        saleQuantity: presupuestador.sumarCantidad
      })

      const integrationCarLotId = presupuestador.stock_owner_id || presupuestador.integration_car_lot_id || presupuestador.nuevo.car_lot_id
      const integrationCarLotName = presupuestador.stock_owner_name ||presupuestador.integration_car_lot_name || presupuestador.nuevo.car_lot_name
      const integrationBranchOfficeId = presupuestador.integration_branch_office_id || presupuestador.nuevo.branch_office_id
      const integrationBranchOfficeName = presupuestador.integration_branch_office_name || presupuestador.nuevo.branch_office_name

      const renderNullIfEmptyString = sentence => sentence && String(sentence).trim() !== '' ? sentence : null

      let body = {
        is_reservation: presupuestador.is_reservation,
        is_nulled: presupuestador.is_nulled,
        branch_office_id: presupuestador.nuevo.branch_office_id,
        branch_office_name: presupuestador.nuevo.branch_office_name,
        car_lot_id: presupuestador.nuevo.car_lot_id,
        catalog_id: presupuestador.nuevo.id,
        catalog_marca: presupuestador.nuevo.brand,
        catalog_model: presupuestador.nuevo.model,
        catalog_version: presupuestador.nuevo.version,
        catalog_patente: presupuestador.nuevo.patente,
        catalog_anio: presupuestador.nuevo.año,
        catalog_price_list: presupuestador.nuevo.precio_lista,
        catalog_flete_alistaje: presupuestador.nuevo.flete_alistaje,
        catalog_bonificacion_fabrica: presupuestador.nuevo.bonificacion,
        catalog_accessory_1: presupuestador.nuevo.accessory_1,
        catalog_accessory_2: presupuestador.nuevo.accessory_2,
        catalog_net_sale_price: presupuestador.nuevo.net_sale_price,
        catalog_nuevo: presupuestador.nuevo.nuevo,
        client_id: presupuestador.cliente.id_cliente,
        client_id_lead: presupuestador.client_id_lead,
        client_first_name: presupuestador.cliente.nombre,
        client_last_name: presupuestador.cliente.apellido,
        client_doc_type: presupuestador.cliente.tipoDoc,
        client_doc: renderNullIfEmptyString(presupuestador?.cliente?.documento),
        client_email: presupuestador.cliente.email,
        client_telefono: presupuestador.cliente.telefono || null,
        client_pais: presupuestador.cliente.pais,
        client_provincia: presupuestador.cliente.provincia,
        client_comment: presupuestador.client_comment,
        sale_type: presupuestador.nuevo.nuevo ? presupuestador.tipoVentaSelected === "venta_directa" ? "DIRECTA" : "CONVENCIONAL" : "USADO",
        sale_quantity: presupuestador.sumarCantidad || 1,
        client_license_plate: presupuestador.client_license_plate,
        stock_id: presupuestador.selectedStock ? presupuestador.selectedStock : presupuestador.stock_id,
        stock_color,
        stock_ubicacion: stock ? stock.ubicacion : null,
        stock_vin: stock ? stock.vin : null,
        stock_sucursal: stock ? stock.sucursal : null,
        stock_estado: stock ? stock.estado : null,
        credit_line_id: presupuestador.selectedLineaFinanciera ? presupuestador.selectedLineaFinanciera : null,
        credit_line_name: lineaFinanciera ? lineaFinanciera.name : null,
        credit_line_banco: lineaFinanciera ? lineaFinanciera.bank : null,
        credit_line_cft: presupuestador.cft ? presupuestador.cft : 0,
        credit_line_tna: valor_tna ? valor_tna : 0,
        credit_line_amount: presupuestador.montoAfinanciar ? presupuestador.montoAfinanciar : 0,
        amount_2b_financed: presupuestador.montoAfinanciar ? Math.trunc(presupuestador.montoAfinanciar) : 0,
        credit_line_fees: presupuestador.cuotasAfinanciar ? presupuestador.cuotasAfinanciar : 0,
        credit_line_first_quote_value: Math.trunc(presupuestador.valorPrimeraCuota) || 0,
        fees_number: presupuestador.cuotasAfinanciar ? presupuestador.cuotasAfinanciar : 0,
        monthly_avg_fee: Math.trunc(presupuestador.cuotaProm),
        credit_line_avg_fees: presupuestador.cuotaProm ? Math.trunc(Number(presupuestador.cuotaProm)) : 0,
        delivery_costs: Math.trunc(presupuestador.costoPatentamiento) || 0,
        delivery_costs_original: truncNumber(presupuestador.costoPatentamientoOriginal),
        delivery_costs_modified: presupuestador.gastosDeEntregaModificados ? presupuestador.gastosDeEntregaModificados : null,
        credit_line_dcosts: Math.trunc(presupuestador.gastosFinanciacion) || 0,
        test_drive: presupuestador.test_drive,
        used_pr_percentage: 0,
        special_discount: presupuestador.special_discount || 0,
        Taking_cars: entrega_usados,
        Reserved_colors: presupuestador.reservedColors,
        observation: presupuestador.observation,
        factor_moneda_local: presupuestador.nuevo.totalSellValue,
        catalog_currencyName: presupuestador.nuevo.currencyName,
        catalog_foreign_currency_symbol: presupuestador.nuevo.foreingCurrencySymbol,
        catalog_currency_symbol: presupuestador.nuevo.currency_symbol,
        id_original_budget: presupuestador.id_original_budget || presupuestador.id,
        id_user_created: presupuestador.id_user_created || common.user.id,
        id_user_edit: common.user.id,
        bonifications: presupuestador.nuevo.bonification,
        car_lot_sales_valid: presupuestador.nuevo.bonification?.car_lot_sales_valid || 0,
        discount_sales_valid: presupuestador.nuevo.bonification?.discount_sales_valid || 0,
        taking_car_sales_valid: presupuestador.nuevo.bonification?.taking_car_sales_valid || 0,
        reservation_credits: JSON.stringify(presupuestador.lineasFinancieras),
        external_id: presupuestador.external_id,
        target: presupuestador.target,
        origin: presupuestador.origin,
        platform: presupuestador.platform,
        discounts_pill: {"N": maxDiscount, "U": usedDiscount},
        stock_comment: presupuestador.nuevo.bonification?.stock_comment || "",
        pay: presupuestador.pay || false,
        integration_car_lot_id: integrationCarLotId,
        integration_car_lot_name: integrationCarLotName,
        integration_branch_office_id: integrationBranchOfficeId,
        integration_branch_office_name: integrationBranchOfficeName,
        lead_id: presupuestador.lead_id,
        client_user_id: presupuestador.client_user_id,
        request_origin: presupuestador.request_origin,
        resale_price_increase: presupuestador.resale_price_increase,
        payments_methods: presupuestador.payments_methods?.length ? presupuestador.payments_methods : null,
      }
      const presupuestoAnterior = {
        delivery_costs: presupuestador.costoPatentamiento || 0
      }

      //TODO: CUANDO SE LEVANTE EL PRESUPUESTO DE UN ROL ID DISTINTO DEL QUE CREO EL PRESUPUESTO TE QUEDA EL PRESUPUESTO COMO SI LO VIESE EL ROL QUE LO CREO
      const tipoVenta = body.sale_type === 'USADO' ? 'USADOS' : body.sale_type
      body.role_bonifications = common.user.discounts.find(item => common.user.role_id === item.role_id && item.car_lot_id === body.car_lot_id && tipoVenta === item.sale_type) || null
      
      const doRequest = axios.post(`${endpoint}`, body)
      
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_SAVE_PRESUPUESTO_SUCCESS,
            data: res,
            presupuesto_anterior: presupuestoAnterior,
            state: res?.data?.data?.state ?? presupuestador.state,
            id_presupuesto: res?.data?.data?.id ?? ''
          })
          resolve(res)
        },
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_SAVE_PRESUPUESTO_FAILURE,
            data: { error: err.message },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSavePresupuestoError() {
  return {
    type: PRESUPUESTADOR_SAVE_PRESUPUESTO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SAVE_PRESUPUESTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        savePresupuestoPending: true,
        savePresupuestoError: null,
        savePresupuestoSuccess: null,
      }

    case PRESUPUESTADOR_SAVE_PRESUPUESTO_SUCCESS:
      // The request is success
      return {
        ...state,
        ...action.data, // TODO: Esta pegando toda la respuesta de la requests en el state, con status, config de AXIOS, etc.
        presupuesto_anterior: action.presupuesto_anterior,
        id_presupuesto: action.id_presupuesto,
        savePresupuestoPending: false,
        savePresupuestoError: null,
        savePresupuestoSuccess: true,
        is_reservation: false,
        is_nulled: false,
        state: action.state,
        getPdfError: null,
        pdf: "",
        disableSave: false,
        pay: false,
        alerts: [],
        opportunity_number: action.data?.data?.data?.opportunity_number,
        version_number: action.data?.data?.data?.version_number
      }

    case PRESUPUESTADOR_SAVE_PRESUPUESTO_FAILURE:
      // The request is failed
      return {
        ...state,
        is_reservation: false,
        is_nulled: false,
        savePresupuestoPending: false,
        savePresupuestoError: action.data.error,
        savePresupuestoSuccess: false,
        pay: false
      }

    case PRESUPUESTADOR_SAVE_PRESUPUESTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        savePresupuestoError: null,
      }

    default:
      return state
  }
}
